import clsx from "clsx"
export default function Navigation({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-(--space-7) h-auto')} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 5H21M3 12H21M3 19H21" stroke="#38362D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
